const missingLocalComponentIds: { [componentId: number]: true } = {};

export const isComponentLocalFileMissing = (componentId: number): boolean => {
	return !!missingLocalComponentIds[componentId];
};

export const markComponentLocalFileMissing = (componentId: number): void => {
	missingLocalComponentIds[componentId] = true;
};

export const clearComponentLocalFileMissing = (componentId: number): void => {
	delete missingLocalComponentIds[componentId];
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/componentLocalFileCache.ts